module.exports = __webpack_public_path__ + "img/active_driver.626b2dea.svg";